import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useGetAllOfferDetailMutation } from "../../../redux/services/offerApi";
import { getUserData } from "../../../redux/slices/authSlice";
import {
  getOffer,
  getOfferTotalPage,
  setOffer,
} from "../../../redux/slices/offerSlice";
import { useAppDispatch, useAppSelector } from "../../../redux/app/hooks";
import { BsFillEmojiFrownFill } from "react-icons/bs";
import Loading from "../../commons/Loading";
import { BiChevronLeft, BiChevronRight } from "react-icons/bi";
import offerImage from "../../../assets/Sidebar (7).png";

type Props = {};

const Offers = (props: Props) => {
  const currentUser: any = JSON.parse(localStorage.getItem("user") || "{}");
  const token: string = currentUser?.jwtToken;
  const customerId = currentUser?.customerId;
  const [getAllOfferDetail, getAllOfferDetailResponse] =
    useGetAllOfferDetailMutation();
  const getOfferData = useAppSelector(getOffer);
  const totalPages = useAppSelector(getOfferTotalPage);
  const [parkingTypes, setParkingTypes] = useState([]);
  const [recordsPerPage, setRecordsPerPage] = useState(4); // Now fetching 4 offers per page (2 rows × 2 columns)
  const [currentPage, setCurrentPage] = useState(0);
  const [sortOrder, setSortOrder] = useState("ASC");
  const dispatch = useAppDispatch();
  const userData = useSelector(getUserData);

  const getAllOfferDetailByPagination = async (
    reqOffset: number,
    reqPage: number,
    reqOrderBy: string
  ) => {
    await getAllOfferDetail({
      token: token,
      payload: {
        offset: reqOffset,
        page: reqPage,
        sortDir: reqOrderBy,
        customerId: customerId,
      },
    });
  };

  useEffect(() => {
    getAllOfferDetailByPagination(recordsPerPage, currentPage, sortOrder);
  }, []);

  useEffect(() => {
    if (getAllOfferDetailResponse.isSuccess) {
      dispatch(setOffer(getAllOfferDetailResponse.data));
    }
  }, [getAllOfferDetailResponse.isSuccess]);

  useEffect(() => {
    if (getOfferData) {
      setParkingTypes(getOfferData);
    }
  }, [getOfferData]);

  const handleLoadMore = async () => {
    setCurrentPage(currentPage + 1);
    getAllOfferDetailByPagination(recordsPerPage, currentPage + 1, sortOrder);
  };

  const handleLoadMores = async () => {
    setCurrentPage(currentPage - 1);
    getAllOfferDetailByPagination(recordsPerPage, currentPage - 1, sortOrder);
  };

  return (
    <div>
      <div className="rounded-[8px] m-[10px] lg:m-[5px] md:mx-[10px] h-auto md:mx-8 mx-2 p-[10px] lg:p-[5px] md:px-[10px]">
        <p className="text-[#434343] font-bold lg:text-[25px] text-[20px] mb-[24px] ml-6">
          Offers
        </p>
        <div className="lg:p-10 p-5 flex justify-center items-center">
          {/* Grid Wrapper - Shows 2 rows × 2 columns per page */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 w-full max-w-3xl">
            {parkingTypes
              .slice(currentPage * recordsPerPage, (currentPage + 1) * recordsPerPage)
              .map((response: any, index: number) => (
                <div key={index} className="flex shadow-md w-full rounded-lg overflow-hidden">
                  {/* Discount Section */}
                  <div className="bg-[#ED1C24] w-[35%] text-center flex items-center justify-center p-6 rounded-lg">
                    <p className="text-white font-bold text-2xl md:text-2xl leading-tight">
                      <span className="block">
                        {response.offerType !== "OTPRCNT" ? "₹" : ""}
                        {response.offerValue}
                        {response.offerType === "OTPRCNT" ? "%" : ""}
                      </span>
                      <span className="block">OFF</span>
                    </p>
                  </div>

                  {/* Offer Details Section */}
                  <div className="flex flex-1 flex-col justify-center bg-[#F9F4EF] p-5">
                    <p className="text-[#1E1E1E] font-bold text-md uppercase">
                      <span id="promo-code">{response.promoCode?.toUpperCase()}</span>
                    </p>
                    <p className="text-[#1E1E1E] text-sm md:text-base font-medium mt-1">
                      {response.offerTitle}
                    </p>
                    <p className="text-gray-500 text-xs md:text-sm mt-2">
                      Valid till{" "}
                      <span id="valid-till">
                        {new Date(response.expiryDate)
                          .toLocaleDateString("en-GB", {
                            day: "2-digit",
                            month: "short",
                            year: "numeric",
                          })
                          .replace(/ /g, " ")}
                      </span>
                    </p>
                  </div>
                </div>
              ))}
          </div>
        </div>

        {parkingTypes && parkingTypes.length === 0 ? (
          <div className="justify-between items-center flex flex-col mt-6 mb-10">
            <h5 className="pt-4">No offers found!!!</h5>
          </div>
        ) : (
          <div className="flex gap-6 justify-center">
            <button
              onClick={() => {
                handleLoadMores();
              }}
              disabled={currentPage == 0}
              className={` p-2 rounded-[8px] flex items-center ${
                currentPage == 0
                  ? "bg-[#58595B] text-white"
                  : "text-white bg-[#ED1C24] "
              }`}
            >
              <BiChevronLeft />
            </button>
            <button
              onClick={() => {
                handleLoadMore();
              }}
              disabled={(currentPage + 1) * recordsPerPage >= parkingTypes.length}
              className={` p-2 flex items-center rounded-[8px] ${
                (currentPage + 1) * recordsPerPage >= parkingTypes.length
                  ? "bg-[#58595B] text-white"
                  : "text-white bg-[#ED1C24] "
              }`}
            >
              <BiChevronRight />
            </button>
          </div>
        )}
        {getAllOfferDetailResponse.isLoading ? <Loading /> : null}
      </div>
      <div className="">
          <img src={offerImage} alt="offers" className="my-10"/>
      </div>
      
      {getAllOfferDetailResponse.isLoading ? <Loading /> : null}
    </div>
  );
};

export default Offers;
